import { Table, TablePaginationConfig, TableProps } from "antd"
import React from "react"
import { useLoggedInEmployeeProfile } from "Shared/queries/employee.queries"
import { useTranslation } from "react-i18next"
import { generatePath, useHistory } from "react-router-dom"
import { RoutePathEnum } from "Shared/router/RoutePath.enum"
import { GeneratePurchaseOrderTodoColumns } from "../columns/PurchaseOrderTodoColumns"
import { PurchaseOrder } from "../types/PurchaseOrder.interfaces"

interface PurchaseOrderTodoTabProps {
    purchaseOrderTodoData: Array<PurchaseOrder>
    pagination: Partial<TablePaginationConfig>
    onTableChange: TableProps<PurchaseOrder>["onChange"]
}
export const PurchaseOrderTodoTab = ({ purchaseOrderTodoData, pagination, onTableChange }: PurchaseOrderTodoTabProps) => {
    const { t } = useTranslation()
    const user = useLoggedInEmployeeProfile()
    const history = useHistory()

    return (
        <>
            <Table
                columns={GeneratePurchaseOrderTodoColumns({
                    t,
                    user: user!,
                })}
                className="custom-table"
                onRow={(record) => ({
                    onClick: () => {
                        history.push(generatePath(RoutePathEnum.PURCHASE_ORDER_DETAILS_PAGE, { id: record._id }))
                    },
                })}
                dataSource={purchaseOrderTodoData}
                showHeader={false}
                scroll={{ scrollToFirstRowOnChange: false, x: "fit-content" }}
                bordered={false}
                onChange={onTableChange}
                pagination={{
                    ...pagination,
                    position: ["bottomRight"],
                    showSizeChanger: true,
                    hideOnSinglePage: false,
                    pageSizeOptions: ["5", "10", "20", "50", "100"],
                }}
            />
        </>
    )
}
